module.exports = __webpack_public_path__ + "media/homepage/gma_logo-1589c069.svg";